import { render, staticRenderFns } from "./PFLoanFront.vue?vue&type=template&id=5162ad7a"
import script from "./PFLoanFront.vue?vue&type=script&lang=js"
export * from "./PFLoanFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports